import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'

import type { FeedbackType } from './types'

interface Props {
  isOpen: boolean
  isLoading?: boolean
  feedbackType: FeedbackType | null
  onClose: () => void
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
}

export const FeedbackDialog = ({
  isOpen,
  isLoading,
  feedbackType,
  onClose,
  onSubmit,
}: Props) => {
  const isPositive = feedbackType === 'positive'
  const label = isPositive
    ? 'Any additional comments? (optional)'
    : 'Why was this data not helpful?'

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth={true}>
      <DialogTitle>Feedback</DialogTitle>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Stack spacing={2}>
            <TextField
              autoFocus
              id="comment"
              name="comment"
              label={label}
              type="text"
              fullWidth
              variant="filled"
              required={!isPositive}
            />
            <DialogActions>
              <Button
                variant="outlined"
                onClick={onClose}
                disabled={isLoading}
                sx={{ height: '40px' }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                type="submit"
                disabled={isLoading}
                sx={{ height: '40px' }}
              >
                {isLoading ? 'Submitting...' : 'Submit feedback'}
              </Button>
            </DialogActions>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  )
}
